
export { 제휴문의URL } from "/vercel/path0/packages/shared-values/src/constants/uri.ts"